import	debounce        from  './debounce'
import	test            from  './test'
import	preventReClick	from  './preventReClick'

export default [
	{	debounce     }, // 防抖指令
	{	test         }, // 测试指令
    { preventReClick }, // 防止重复点击指令
]